import styled from 'styled-components';

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: #f4f4f4;
`;

export const Heading = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

export const Title = styled.h2`
  font-size: 2.5em;
  color: #333;
  margin-bottom: 10px;
`;

export const Subtitle = styled.p`
  font-size: 1.1em;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.5;
`;

export const AccordionItem = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 15px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  font-size: 1.1em;
  color: #333;

  &:hover {
    background-color: #f9f9f9;
  }
`;

export const AccordionContent = styled.div`
  padding: 20px;
  background-color: #fefefe;
  transition: all 0.3s ease-in-out;
  border-top: 1px solid #eee;
  font-size: 1em;
  line-height: 1.6;
  color: #555;
`;